import { render, staticRenderFns } from "./InventoryMenu.vue?vue&type=template&id=43133496&scoped=true&"
import script from "./InventoryMenu.vue?vue&type=script&lang=js&"
export * from "./InventoryMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43133496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43133496')) {
      api.createRecord('43133496', component.options)
    } else {
      api.reload('43133496', component.options)
    }
    module.hot.accept("./InventoryMenu.vue?vue&type=template&id=43133496&scoped=true&", function () {
      api.rerender('43133496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/InventoryMenu.vue"
export default component.exports